import { RouteRecordRaw } from 'vue-router';
import { deltaGptRoutes, getResearchRoutes } from '../deltaGptRoutes.ts';
import { SectionRouteNames, ResidentialResearchNames } from './sectionRouteNames.ts';

export const residentialRoutes: Record<string, RouteRecordRaw> = {
    home: {
        path: '',
        name: `${SectionRouteNames.residential}Home`,
        components: {
            default: () => import('@/views/sectionViews/residential/ResidentialHomeView.vue'),
        },
        meta: {
            headName: 'Residential Home',
            displayTitle: 'Home',
        },
    },
    smartEnergy: {
        path: 'smart-energy/research',
        name: `${ResidentialResearchNames.smartEnergyResearch}`,
        redirect: { name: `${ResidentialResearchNames.smartEnergyResearch}_${deltaGptRoutes.documentList.name as string}` },
        children: getResearchRoutes(`${ResidentialResearchNames.smartEnergyResearch}`),
        meta: {
            headName: 'Smart Energy',
            searchMeta: {
                tags: ['research', 'home energy management', 'hem', 'new energy strategies', 'nes'],
            },
        },
    },
    heat: {
        path: 'heat/research',
        name: `${ResidentialResearchNames.heatResearch}`,
        redirect: { name: `${ResidentialResearchNames.heatResearch}_${deltaGptRoutes.documentList.name as string}` },
        children: getResearchRoutes(`${ResidentialResearchNames.heatResearch}`),
        meta: {
            headName: 'Heat',
            searchMeta: {
                tags: ['research'],
            },
        },
    },
    solarAndBattery: {
        path: 'solar-and-battery/research',
        name: `${ResidentialResearchNames.solarAndBatteryResearch}`,
        redirect: { name: `${ResidentialResearchNames.solarAndBatteryResearch}_${deltaGptRoutes.documentList.name as string}` },
        children: getResearchRoutes(`${ResidentialResearchNames.solarAndBatteryResearch}`),
        meta: {
            headName: 'Solar & Battery',
            searchMeta: {
                tags: ['research'],
            },
        },
    },
    evCharging: {
        path: 'ev-charging/research',
        name: `${ResidentialResearchNames.evChargingResearch}`,
        redirect: { name: `${ResidentialResearchNames.evChargingResearch}_${deltaGptRoutes.documentList.name as string}` },
        children: getResearchRoutes(`${ResidentialResearchNames.evChargingResearch}`),
        meta: {
            headName: 'EV Charging',
            searchMeta: {
                tags: ['research'],
            },
        },
    },
    all: {
        path: 'all/research',
        name: `${ResidentialResearchNames.residentialAll}`,
        redirect: { name: `${ResidentialResearchNames.residentialAll}_${deltaGptRoutes.documentList.name as string}` },
        children: getResearchRoutes(`${ResidentialResearchNames.residentialAll}`),
        meta: {
            headName: 'All',
            searchMeta: {
                tags: ['research'],
            },
        },
    },
    enact: {
        path: 'enact',
        name: `${SectionRouteNames.residential}Enact`,
        redirect: { name: 'EV Flexibility Index' },
        components: {
            default: () => import('@/views/powerMarkets/benchmarks/FlexIndexView.vue'),
        },
        meta: {
            headName: 'Enact',
            displayTitle: 'Enact',
            showChildrenInNavbar: true,
            showChildrenInNavDropdown: true,
            searchMeta: {
                tags: ['enact'],
            },
        },
        children: [
            {
                path: 'ev-flexibility-index',
                name: 'EV Flexibility Index',
                components: {
                    default: () => import('@/views/powerMarkets/benchmarks/FlexIndexView.vue'),
                },
                meta: {
                    headName: 'EV Flexibility Index',
                    accessName: 'flex-index',
                    isEnact: true,
                    searchMeta: {
                        tags: ['battery', 'storage', 'BESS', 'indices', 'leaderboard', 'EV', 'flex'],
                    },
                },
            },
        ],
    },
};
